import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TestimonialSlideConverter extends CmsConverterService<TestimonialSlideData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData?.st_lazy?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      imagePosition: formData?.st_image_position?.value?.identifier ?? '',
      text: formData?.st_text ?? defaultTextInput,
      textFont: formData?.st_font_size?.value?.identifier ?? '',
      name: formData?.st_name ?? defaultTextInput,
      position: formData?.st_position ?? defaultTextInput,
      location: formData?.st_location ?? defaultTextInput,
      backgroundColor: formData?.st_backgroundcolor?.value?.identifier ?? '',
      quotes: formData?.st_quotes?.value?.identifier ?? ''
    }
  }
}

export const TESTIMONIAL_SLIDE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, TestimonialSlideData>>('TestimonialSlideConverter')

export interface TestimonialSlideData extends ConvertedComponentData {
  imagePosition: string;
  image: Image;
  text: TextInput;
  textFont: string;
  name: TextInput;
  position: TextInput;
  location: TextInput;
  backgroundColor: string;
  quotes: string;
}
